export function getPlatform () {
  // @ts-ignore
  if (typeof window.ReactNativeWebView !== 'undefined') {
    return 'app';
  }
  return 'web';
}
